// src/fleet-stats/constants.js

export const C = {
    blueBlack: "#021c23",
    darkBlue: "#04252e",
    deepBlue: "#073440",
    strongBlue: "#09465f",
    grey3: "#395d66",
    grey2: "#9caeb3",
    grey1: "#cdd6d9",
    offWhite: "#efefef",
    neonGreen: "#7bff89",
    amber: "#f5a623",
    red: "#ff5f5f",
};

export const PAGE_BG = `linear-gradient(180deg, ${C.blueBlack} 0%, ${C.darkBlue} 100%)`;
export const CARD_BG = "rgba(255,255,255,0.025)";
export const CARD_BORDER = "1px solid rgba(255,255,255,0.06)";
export const SUBTLE_BORDER = "rgba(205,214,217,0.28)";
export const EARTH_KM = 40075;

// Anomaly detection thresholds
export const ANOMALY_DROP_THRESHOLD = 0.5;
export const ANOMALY_SPIKE_THRESHOLD = 2.5;
export const BASELINE_WINDOW_DAYS = 21;
export const RECENT_WINDOW_DAYS = 7;
export const INACTIVE_CUTOFF_DAYS = 7;
export const IDLE_UTILIZATION_THRESHOLD = 0.1;

// ── Robot Readiness Index (RRI) ──────────────────────────────────────────────
// Three-factor model based on Bechtsis et al. (2022), "Data-driven autonomous
// robot performance assessment", International Journal of Production Research.
// All factors are self-referential per Boysen et al. (2021), EJOR.
//
// RRI = (Consistency × 0.5) + (Productive Ratio × 0.3) + (Stability × 0.2) × 100
//
// Consistency (0.5): recent 7d avg driving time vs own 21d baseline.
// Productive Ratio (0.3): moving_time / uptime — proxy for autonomous driving ratio.
// Stability (0.2): proportion of recent days within normal range vs own rolling avg.
//
// See robotHealth.js for full methodology and weight rationale.

export const RRI_BANDS = [
    { min: 80, max: 100, label: "Optimal",         color: "#7bff89" },
    { min: 60, max: 79,  label: "Operational",     color: "#a8e063" },
    { min: 40, max: 59,  label: "Underperforming", color: "#f5a623" },
    { min: 20, max: 39,  label: "At risk",         color: "#ff8c5f" },
    { min: 0,  max: 19,  label: "Inactive",        color: "#ff5f5f" },
];

export const RRI_LABEL_INSUFFICIENT = "Insufficient data";
export const RRI_COLOR_INSUFFICIENT = "#9caeb3";
export const RRI_LABEL_ESTIMATED    = "Estimated";  // new robot, using site peers

export function getRRIBand(score) {
    if (score === null || score === undefined) return { label: RRI_LABEL_INSUFFICIENT, color: RRI_COLOR_INSUFFICIENT };
    return RRI_BANDS.find((b) => score >= b.min && score <= b.max) || RRI_BANDS[RRI_BANDS.length - 1];
}